<div class="title">
  <h3>Delivery ready</h3>
</div>
@if (batches.length) {
  <div class="columns">
    @for (column of columns; track $index) {
      <div>{{ column }}</div>
    }
  </div>
}
@if (batches.length) {
  <cdk-virtual-scroll-viewport [style.height.px]="400" itemSize="80">
    <div
      *cdkVirtualFor="let batch of batches | filterBatches: filterText | onlyWithOrders; trackBy: trackByFn"
      class="batch-list">
      <fulfill-batch-list-table-row [batch]="batch" state="deliveryReady"></fulfill-batch-list-table-row></div
  ></cdk-virtual-scroll-viewport>
}
